import { Transaction as TransactionType } from '../types';
import { AdImage } from '@finn-no/tjt-common-components';
import NotificationDot from '../../components/NotificationDot';
import { createTransactionLink } from './utils';
import pulseClient from '../../pulse-tracking';
import {i18n} from "@lingui/core";
import { t } from '../../../i18n/texts';

type Props = {
    transaction: TransactionType;
};

const Transaction = ({ transaction }: Props) => {
    const { adIds, statusString, title, image } = transaction;

    const trackTransactionClick = () => pulseClient.trackAdClick(adIds && adIds[0], statusString);
    const transactionLink = createTransactionLink(transaction);

    return (
        <article
            className={`tjt-transaction-item relative flex justify-between items-center flex-row-reverse p-12 mb-0 lg:mb-12 border border-solid s-border rounded-8 hover:s-bg-primary-subtle active:s-bg-primary-subtle-hover`}
        >
            <div className="pl-12 grow flex flex-col-reverse truncate">
                <h3 className="text-s font-normal mb-0 truncate">{title}</h3>
                <a
                    href={transactionLink}
                    className={`font-bold mb-0 s-text hover:no-underline truncate`}
                    onClick={trackTransactionClick}
                >
                    {statusString}
                </a>
            </div>

            <div className="relative shrink-0">
                <NotificationDot />
                <AdImage
                    alt={
                        image ? i18n._(t.adImage.alt) : i18n._(t.adImage.defaultImgAlt)
                    }
                    image={image}
                    numberOfAds={transaction.numberOfAds}
                    roundedBorder={true}
                    sizeStyleClasses={'min-w-[48] w-[48] h-[48]'}
                />
            </div>
        </article>
    );
};

export default Transaction;
